import React from 'react';

interface LoadingScreenProps {
  message?: string;
  size?: 'small' | 'medium' | 'large';
  fullScreen?: boolean;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({ 
  message = 'Loading...', 
  size = 'large',
  fullScreen = true 
}) => {
  const sizeClasses = {
    small: 'w-32 h-16',
    medium: 'w-48 h-24',
    large: 'w-64 h-32'
  };

  const containerClasses = fullScreen 
    ? 'min-h-screen bg-gradient-to-br from-sky-50 via-white to-orange-50' 
    : '';

  return (
    <div className={`flex flex-col items-center justify-center ${containerClasses}`}>
      <div className="relative flex flex-col items-center">
        <div className="relative">
          <img 
            src="/splash-logo.png" 
            alt="Volexx Logistics" 
            className={`${sizeClasses[size]} object-contain animate-pulse`}
            style={{ animationDuration: '2s' }}
          />
        </div>
        
        <div className="mt-6 flex items-center gap-1">
          <div className="w-2 h-2 bg-sky-500 rounded-full animate-bounce" style={{ animationDelay: '0ms' }} />
          <div className="w-2 h-2 bg-sky-400 rounded-full animate-bounce" style={{ animationDelay: '150ms' }} />
          <div className="w-2 h-2 bg-orange-400 rounded-full animate-bounce" style={{ animationDelay: '300ms' }} />
        </div>
        
        {message && (
          <p className="mt-4 text-gray-600 font-medium text-sm sm:text-base animate-pulse">
            {message}
          </p>
        )}
      </div>
    </div>
  );
};

export default LoadingScreen;
